import type { Middleware } from "@connect/data/frames/client";

const CHECKOUT_SESSION_ID_HEADER = "X-Checkout-Session-Id";
const FRAMES_CREATE_CARD_PATH = "/platform/v1/frames/payment-methods/cards";

/**
 * Attaches the Checkout.com risk session id to the Frames card-create call for
 * server-side risk scoring. Scoped to POST create so list-cards GETs on the
 * same path are untouched. An empty id (SDK unavailable) is omitted.
 */
export function createCheckoutSessionMiddleware(getSessionId: () => Promise<string>): Middleware {
  return {
    async onRequest({ request }) {
      const isCardCreate =
        request.method === "POST" &&
        new URL(request.url).pathname.endsWith(FRAMES_CREATE_CARD_PATH);
      if (!isCardCreate || request.headers.has(CHECKOUT_SESSION_ID_HEADER)) {
        return request;
      }
      const sessionId = await getSessionId();
      if (sessionId) {
        request.headers.set(CHECKOUT_SESSION_ID_HEADER, sessionId);
      }
      return request;
    },
  };
}
